module.exports = __webpack_public_path__ + "img/type1_bg1.c0ac77cd.png";